export const SPACINGS = {
  SIZE_PX: "1px",
  SIZE_0_5: "2px",
  SIZE_1: "4px",
  SIZE_1_5: "6px",
  SIZE_2: "8px",
  SIZE_2_5: "10px",
  SIZE_3: "12px",
  SIZE_4: "16px",
  SIZE_5: "20px",
  SIZE_6: "24px",
  SIZE_8: "32px",
  SIZE_9: "36px",
  SIZE_10: "40px",
  SIZE_11: "44px",
  SIZE_12: "48px",
  SIZE_13: "52px",
  SIZE_14: "56px",
  SIZE_15: "60px",
  SIZE_16: "64px",
};
